import type { CentrifugeMessage } from '../messageTypes';

export interface InfoMessageUnparsed {
  data: { type: 'Info'; message: string; created_at?: number };
  seq: undefined;
  gen: undefined;
  offset: number;
}

export interface InfoMessage {
  data: {
    type: 'Info';
    message: { nick: string; name: string; name_ja: string; name_en: string };
    created_at?: number;
  };
  seq?: undefined;
  gen?: undefined;
  offset: number;
  key?: string;
}

export const isInfoMessage = (item: CentrifugeMessage): item is InfoMessage => {
  return 'data' in item && item.data.type === 'Info';
};

export interface FanUpMessage {
  data: {
    type: 'FanUp';
    message: { nick: string; rank: number };
    created_at?: number;
  };
  seq?: undefined;
  gen?: undefined;
  offset: number;
}

export const isFanUpMessage = (item: CentrifugeMessage): item is FanUpMessage => {
  return 'data' in item && item.data.type === 'FanUp';
};

export interface KingFanUpMessage {
  data: {
    type: 'KingFanUp';
    message: { nick: string };
    created_at?: number;
  };
  seq?: undefined;
  gen?: undefined;
  offset: number;
}

export const isKingFanUpMessage = (item: CentrifugeMessage): item is KingFanUpMessage => {
  return 'data' in item && item.data.type === 'KingFanUp';
};
